/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";
import React from "react";

export const DeliveryNoteRowSkeletonMobile = (props) => (
    <ContentLoader
        width={"100%"}
        height={200}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{backgroundColor: "#fff", borderRadius: "4px", marginBottom: "12px"}}
        {...props}>

        {/* Delivery number */}
        <rect x="16" y="16" rx="3" ry="3" width="25%" height="10"/>
        <rect x="16" y="36" rx="3" ry="3" width="25%" height="10"/>

        {/* Ship to */}
        <rect x="12" y="40%" rx="3" ry="3" width="15%" height="10"/>
        <rect x="12" y={`calc(40% + 20px)`} rx="3" ry="3" width="25%" height="10"/>

        {/* City */}
        <rect x={`calc(12px + 33.33%)`} y="40%" rx="3" ry="3" width="15%" height="10"/>
        <rect x={`calc(12px + 33.33%)`} y={`calc(40% + 20px)`} rx="3" ry="3" width="25%" height="10"/>

        {/* Goods issue date */}
        <rect x={`calc(12px + 66.66%)`} y="40%" rx="3" ry="3" width="15%" height="10"/>
        <rect x={`calc(12px + 66.66%)`} y={`calc(40% + 20px)`} rx="3" ry="3" width="25%" height="10"/>

        {/* Download */}
        <rect x="5%" y={`calc(100% - 50px)`} rx="3" ry="3" width="90%" height="30"/>

    </ContentLoader>
);
